<template>
  <v-container class="media-header">
    <v-row justify="center" align="center">
      <v-col cols="auto">
        <v-btn v-if="displaySideNavigation" href="/" small outlined icon :color="color">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn v-if="!displaySideNavigation && !mx_isLeftDrawerOpen" @click="mx_isLeftDrawerOpen = true" small icon :color="color">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
        <v-btn v-if="!displaySideNavigation && mx_isLeftDrawerOpen" @click="mx_isLeftDrawerOpen = false" small icon :color="color">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-col>
      <v-col class="pl-0" @click="$router.push('/')">
        <div :class="`${theme.appBar.other.color}--text`">{{ currentModuleName }}</div>
        <v-spacer></v-spacer>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import common from '@/mixins/common';
import { mapState } from 'vuex';

export default {
  name: 'Media',
  mixins: [common],
  data() {
    return {};
  },
  computed: {
    ...mapState('media', ['containersById']),
    color() {
      return this.theme.appBar.other.color;
    },
    currentModuleId() {
      return this.$route.params.instance || 0;
    },
    currentModule() {
      return this.containersById[this.currentModuleId] || {};
    },

    currentModuleName() {
      return this.currentModule?.properties?.name || '...';
    },

    currentFolderName() {
      return this.currentFolder?.properties?.name;
    },

    displaySideNavigation() {
      return !this.smAndDown;
    },
  },
};
</script>
